module.exports = __webpack_public_path__ + "static/img/1-1.885df45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/1-1.png
// module id = dlRp
// module chunks = 1